/**
 * Orderwerks Catalog Item fields whose QBD item sync behavior can be configured per supplier
 * (see IQBDItemFieldMapping). Values are the Catalog_Item column names.
 */
enum QBDItemMappableFieldEnum {
    name = "name",
    sku = "sku",
    description = "description",
    upc = "upc",
    msrp = "msrp",
    cost_per_uom = "cost_per_uom",
    unit_of_measurement_id = "unit_of_measurement_id",
    is_taxable = "is_taxable",
    active = "active",
}

export default QBDItemMappableFieldEnum;
